<template>
  <component-redirecting/>
</template>

<script>
import ComponentRedirecting from '@/components/default/shared/ComponentRedirecting'

export default {
  components: { ComponentRedirecting },
  name: 'landing-invitation',
  computed: {
    loggedInUserId () {
      return this.$store.getters.getAuthUserFirstStageTokenDataID || this.$store.getters.getAuthUserSecondStageTokenDataUserId
    }
  },
  methods: {
    handleInvitation () {
      const route = this.$route
      const invitationType = route.query.type
      const invitationId = route.query.invitation
      const userId = route.query.userId
      const redirectError = () => {
        return this.$router.push({ name: 'lms-user-invitation-error', query: { type: invitationType, invitationId: invitationId } })
      }
      const redirectReject = () => {
        return this.$router.push({ name: 'lms-user-invitation-reject', query: { invitation: invitationId } })
      }
      const redirectResolved = () => {
        return this.$router.push({ name: 'lms-user-invitation-resolved', query: { invitation: invitationId } })
      }
      const redirectAcceptLoggedIn = () => {
        return this.$router.push({ name: 'lms-user-invitation-accept', query: { invitation: invitationId } })
      }
      const redirectAcceptNotLoggedIn = () => {
        return this.$router.push({ name: 'auth-login', query: { invitation: invitationId } })
      }

      if (route.name !== 'landing-invitation') return

      this.$store.dispatch('lmsUserInvitationGet', invitationId).then(response => {
        const userEmail = response.email
        const userFirstName = response.firstName
        const userLastName = response.lastName
        const isUserRegisteredInCognito = response.cognitoRegistered
        const isUserLoggedIn = this.loggedInUserId === userId

        if (invitationType === 'accept') {
          if (isUserRegisteredInCognito) {
            this.$store.dispatch('lmsUserInvitationAccept', invitationId).then(() => {
              if (isUserLoggedIn) {
                redirectAcceptLoggedIn()
              } else {
                this.$store.dispatch('authUserSetLoginUsername', userEmail)
                redirectAcceptNotLoggedIn()
              }
            }).catch(() => {
              redirectError()
            })
          } else {
            this.$store.dispatch('authUserSetSignUpInvitation', invitationId)
            this.$store.dispatch('authUserSetSignUpId', userId)
            this.$store.dispatch('authUserSetSignUpEmail', userEmail)
            this.$store.dispatch('authUserSetSignUpFirstName', userFirstName)
            this.$store.dispatch('authUserSetSignUpLastName', userLastName)
            this.$router.push({ name: 'auth-signup' })
          }
        } else if (invitationType === 'reject') {
          this.$store.dispatch('lmsUserInvitationReject', invitationId).then(() => {
            redirectReject()
          }).catch(() => {
            redirectError()
          })
        } else {
          redirectError()
        }
      }).catch(() => {
        redirectResolved()
      })
    }
  },
  mounted () {
    this.handleInvitation()
  }
}
</script>
